import Axios from "axios";

const BASE_URL = `${import.meta.env.VITE_BASE_URL_API_BACKEND}/action-plans`;

export default class actionPlansService {
  static get = async (params) => {
    try {
      const { data } = await Axios.get(BASE_URL, { params });
      return data;
    } catch (error) {
      console.error("Erro /action-plans:", error);
      throw error;
    }
  };

  static getById = async (id) => {
    try {
      const { data } = await Axios.get(`${BASE_URL}/${id}`);
      return data;
    } catch {
      return false;
    }
  };

  static post = async (payload) => {
    try {
      const { data } = await Axios.post(BASE_URL, payload);
      return data;
    } catch {
      return false;
    }
  };

  static put = async (id, payload) => {
    const { data } = await Axios.put(`${BASE_URL}/${id}`, payload);
    return data;
  };

  static delete = async (id) => {
    try {
      await Axios.delete(`${BASE_URL}/${id}`);
      return true;
    } catch {
      return false;
    }
  };

  static getOverview = async () => {
    try {
      const { data } = await Axios.get(`${BASE_URL}/overview`);
      return data;
    } catch (error) {
      console.error("Erro /action-plans/overview:", error);
      throw error;
    }
  };
}
